"use client";
import { Button, ButtonProps } from "antd";
import "./index.css";
import Image from "next/image";
import { useCallback, useEffect, useRef, useState } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { usePathname, useSearchParams } from "next/navigation";

export type BravveSmartButtonProps = {
  iconHeight?: number;
  iconWidth?: number;
  isLoading?: boolean;
  onClick?: () => void;
  className?: string;
  children?: string | React.ReactNode;
  time?: number;
  /** 新增属性：标记本次点击是否触发路由跳转 */
  isNavigation?: boolean;
};
export const BravveSmartButton: React.FC<
  ButtonProps & BravveSmartButtonProps
> = ({ ...props }) => {
  const {
    iconHeight = 30,
    iconWidth = 30,
    children,
    isLoading = false,
    time = 0,
    isNavigation = false,
    ...buttonProps // 获取剩余的所有其他props
  } = props;

  const { onClick, type = "default" } = props;

  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [loading, setLoading] = useState(isLoading);
  const loadingTimeoutRef = useRef<number | null>(null);

  // 监听所有路由变化（包括 pathname 和 searchParams）
  useEffect(() => {
    if (isLoading) {
      setLoading(false);
      // 清除可能存在的超时定时器
      if (loadingTimeoutRef.current) {
        clearTimeout(loadingTimeoutRef.current);
      }
    }
  }, [pathname, searchParams]); // 同时监听路径和查询参数变化

  const onButtonClick = useCallback(async () => {
    setLoading(true);

    if (isNavigation) {
      // 如果是路由跳转，直接执行不等待
      onClick?.();
      return;
    }

    try {
      if (!onClick) return;

      const result: any = onClick();

      // 路由跳转无需等待 Promise
      if (isNavigation) return;

      if (result instanceof Promise) {
        await result; // 等待 Promise 结束
      }
    } catch (error) {
      console.error("onClick 执行失败：", error);
    } finally {
      if (!time) {
        setLoading(false);
        return;
      }

      if (isNavigation) return;

      loadingTimeoutRef.current = window.setTimeout(() => {
        setLoading(false);
      }, time);
    }
  }, [onClick, isNavigation]);

  // 组件卸载时清除状态
  useEffect(() => {
    return () => {
      setLoading(false);
      if (loadingTimeoutRef.current) {
        clearTimeout(loadingTimeoutRef.current as number);
      }
    };
  }, []);

  return (
    <Button
      {...buttonProps}
      onClick={onButtonClick}
      icon={
        loading && (
          <LoadingOutlined color={type == "default" ? "#402c22" : "#fff"} />
        )
        // (
        //   <Image
        //     src={
        //       type == "default"
        //         ? "/img/index/Loading.gif"
        //         : "/img/index/Loading_white.gif"
        //     }
        //     alt="Loading"
        //     width={iconWidth}
        //     height={iconHeight}
        //     style={{ width: iconWidth || "30px", height: iconHeight || "30px" }}
        //   />
        // )
      }
    >
      {loading ? "Loading..." : children}
    </Button>
  );
};
